/****** SLICK CONFIG *******/


    $(document).ready(function(){
        $('.js-slideshow').slick({
            dots: true,
            arrows:true,
            //infinite: true,
            speed: 500,
            //fade: true,
            //cssEase: 'linear'
            responsive: [
			    {
			      breakpoint: 480,
			      settings: {
			        centerMode: false,
			        centerPadding: '10px',
			        dots: true,
			        arrows: true
			      }
			    }
			]
        });
        $('.js-textshow').slick({
            dots: true,
            arrows:false,
            infinite: true,
            speed: 1000,
            autoplay: true,
            autoplaySpeed: 8000,
            //fade: true,
            //cssEase: 'linear'
            responsive: [
                {
                  breakpoint: 480,
                  settings: {
                    dots: true,
                    arrows: false
                  }
                }
            ]
        });
    });